import * as API from '../api';
import {
  CATEGORY_FIND_ALL,
  CATEGORY_NORMALISE,
  CATEGORY_SET,
  ACTION_PROMISE,
  SHOW_ERROR,
  CATEGORY_FIND_ONE,
  CATEGORY_SET_DESCRIPTION,
  ITEM_FIND_ONE,
  ITEM_SET,
  CATEGORY_ITEM_FIND_REQUEST,
  CATEGORY_ITEMS_SET,
  CATEGORY_SEARCH_ITEM
} from "../utils/Constant";

export function findAll(withProducts = false) {
  return {
    type: ACTION_PROMISE,
    actions: [CATEGORY_FIND_ALL, CATEGORY_SET, SHOW_ERROR, CATEGORY_NORMALISE],
    promise: API.catalog.findAll(withProducts),
  }
}

export function loadPlaygroundFromDb(hash) {
  return {
    type: ACTION_PROMISE,
    actions: [CATEGORY_FIND_ALL, CATEGORY_SET, SHOW_ERROR, CATEGORY_NORMALISE],
    promise: API.catalog.loadPlaygroundFromDb(hash),
  }
}

export function findAllItemByCategoryId(id) {

  return {
    type: ACTION_PROMISE,
    actions: [CATEGORY_ITEM_FIND_REQUEST, CATEGORY_ITEMS_SET, SHOW_ERROR],
    promise: API.catalog.findAllItemByCategoryId(id),
  }
}

export function getItemBySlug(slug) {
  return {
    type: ACTION_PROMISE,
    actions: [ITEM_FIND_ONE, ITEM_SET, SHOW_ERROR],
    promise: API.catalog.getItemBySlug(slug),
  }
}

export function findBySlug(slug) {
  return {
    type: ACTION_PROMISE,
    actions: [CATEGORY_FIND_ONE, CATEGORY_SET, SHOW_ERROR],
    promise: API.catalog.findBySlug(slug),
  }
}

export function getParamBySlug(slug, param) {
  return {
    type: ACTION_PROMISE,
    actions: [CATEGORY_FIND_ONE, CATEGORY_SET, SHOW_ERROR, CATEGORY_SET_DESCRIPTION],
    promise: API.catalog.getParamBySlug(slug, param),
  }
}


export function search(searchText) {
  return {
    type: CATEGORY_SEARCH_ITEM,
    data: {searchText}
  };
}
